import { useContext } from "react";
import DataContext from "./DataContext";
import { DataContextType } from "../../types";

export const useDataContext = (): DataContextType => {
    const context = useContext(DataContext);

    if (!context) {
        throw new Error("The context hook is being used in a component that is not involved in the Provider.");
    }

    return context;
}

export default useDataContext;
